<template>
  <div></div>
</template>

<script>
export default {
  name: "AlipayCallback",
  mounted() {
    this.load()
  },
  data() {
    return {
      loginUrl: '/api/alipay/login',
      registerUrl: '/api/alipay/register',
      bindingUrl: '/api/alipay/binding',
    }
  },
  methods: {
    load() {
      let auth_code = this.$route.query.auth_code
      if (auth_code != null) {
        let type = localStorage.getItem('alipay_back')
        localStorage.removeItem('alipay_back')
        if (type === 'register') {
          this.register(auth_code)
        } else {
          this.binding(auth_code)
        }
      } else {
        this.$router.replace('/m_login')
      }
    },
    register(auth_code) {
      let machineType = this.getMachineType()
      this.$ajax({
        method: 'get',
        url: this.loginUrl,
        params: {code: auth_code, platformType: machineType}
      }).then((response) => {
        let responseData = JSON.parse(response.data['responseData']);
        let userId = responseData['userId']
        if (response.data.result) {
          localStorage.setItem('islogin', '1')
          localStorage.setItem('loginTime', new Date().getTime().toString())
          localStorage.setItem('account', userId)
          localStorage.setItem('accountType', 'Alipay')
          localStorage.setItem('yhnm', responseData['yhnm'])
          localStorage.setItem('token', responseData['token'])
          this.$router.replace('/m_birthday')
        } else {
          if (response.data['errorCode'] === "UnRegistered") {
            this.$messagebox.confirm("您还未注册平台帐号，点击确定自动注册，是否继续?").then(action => {
              if (action === 'confirm') {
                this.$ajax({
                  method: 'get',
                  url: this.registerUrl,
                  params: {access_token: responseData['access_token'], userId: userId, platformType: machineType}
                }).then((response) => {
                  let responseData = JSON.parse(response.data['responseData']);
                  localStorage.setItem('islogin', '1')
                  localStorage.setItem('loginTime', new Date().getTime().toString())
                  localStorage.setItem('account', userId)
                  localStorage.setItem('accountType', 'Alipay')
                  localStorage.setItem('token', responseData['token'])
                  localStorage.setItem('yhnm', responseData['yhnm'])
                  this.$router.replace('/m_birthday')
                }).catch(response => {
                  this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
                })
              } else {
                this.$router.replace('/m_login')
              }
            })
          } else
            this.$messagebox.alert(response.data.message, '服务器返回错误')
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    binding(auth_code) {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.bindingUrl,
        params: {
          code: auth_code,
          yhnm: localStorage.getItem('yhnm'),
        },
        headers: {token: localStorage.getItem('token')}
      }).then((response) => {
        if (!response.data.result) {
          that.$messagebox.alert(response.data.message)
        }
        this.$router.replace('/m_account_setting')
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    _isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    }
  }
}
</script>

<style scoped>

</style>
